// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3G6Ju","title":"Images45_title__3w6B7","images":"Images45_images__1Jigs"};